import { createFileRoute, notFound } from "@tanstack/react-router";
import { getDesignSystemPage } from "~/features/design-system/registry";

export const Route = createFileRoute("/design-system/$slug")({
  loader: ({ params }) => {
    if (getDesignSystemPage(params.slug) === undefined) {
      throw notFound();
    }
  },
});
